// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"2d5623aa","90":"6b86431e"}[chunkId] + ".chunk.css";
};